import React from 'react';
import './SocialLoginComponent.less';
import GoogleAuthComponent from '../GoogleAuthComponent/GoogleAuthComponent';
import FacebookAuthComponent from '../FacebookAuthComponent/FacebookAuthComponent';
import ExpediaAuthComponent from '../ExpediaAuthComponent/ExpediaAuthComponent';

function SocialLoginComponent({actionLocation, disableLoading, emailAddress, enableLoading, expediaIconDisplayed, handleError, handleLoginSuccess, lingua, locale, marketingOptOut, onClose, performBulkPageUpdate, setAuthJson, site, updatePage}) {
    return (
        <div>
            <label className="SocialLoginComponent text-center"> {lingua.read('lex.social.or.text')}
                <span className="sr-only">{'SocialLoginComponent'}</span>
            </label>
            <div className="SocialLoginIcons">
                {expediaIconDisplayed === true &&
                    <div className="SocialLoginIcons__icon">
                        <ExpediaAuthComponent
                            id="expediaSocial"
                            name="expediaSocial"
                            actionLocation={actionLocation}
                            enableLoading={enableLoading}
                            disableLoading={disableLoading}
                            lingua={lingua}
                            handleError={handleError}
                            onClose={onClose}
                            handleLoginSuccess={handleLoginSuccess}
                            updatePage={updatePage}
                            setAuthJson={setAuthJson}
                            performBulkPageUpdate={performBulkPageUpdate}
                            site={site}
                            emailAddress={emailAddress}
                            expediaIconDisplayed={expediaIconDisplayed}
                            marketingOptOut={marketingOptOut}
                        />
                    </div>
                }
                {expediaIconDisplayed !== true &&
                    <div/>
                }
                <div className="SocialLoginIcons__icon">
                    <GoogleAuthComponent
                        id="googleSocial"
                        name="googleSocial"
                        actionLocation={actionLocation}
                        enableLoading={enableLoading}
                        disableLoading={disableLoading}
                        lingua={lingua}
                        handleError={handleError}
                        onClose={onClose}
                        handleLoginSuccess={handleLoginSuccess}
                        updatePage={updatePage}
                        setAuthJson={setAuthJson}
                        performBulkPageUpdate={performBulkPageUpdate}
                        site={site}
                        emailAddress={emailAddress}
                        expediaIconDisplayed={expediaIconDisplayed}
                        marketingOptOut={marketingOptOut}
                    />
                </div>
                <div className="SocialLoginIcons__icon">
                    <FacebookAuthComponent
                        id="facebookSocial"
                        name="facebookSocial"
                        actionLocation={actionLocation}
                        enableLoading={enableLoading}
                        disableLoading={disableLoading}
                        lingua={lingua}
                        handleError={handleError}
                        locale={locale}
                        onClose={onClose}
                        handleLoginSuccess={handleLoginSuccess}
                        updatePage={updatePage}
                        setAuthJson={setAuthJson}
                        performBulkPageUpdate={performBulkPageUpdate}
                        site={site}
                        emailAddress={emailAddress}
                        expediaIconDisplayed={expediaIconDisplayed}
                        marketingOptOut={marketingOptOut}
                    />
                </div>
            </div>
        </div>
    );
}

export default SocialLoginComponent;
